<template>
  <div>
    <div class="row mt-5 border-top p-2">
      <div class="col mt-3">
        <h4>Effectiveness Evaluation</h4>
      </div>
    </div>

    <div class="row p-2">
      <div class="col min-width-chart mx-auto my-auto pb-3">
        <doughnutChart
          :chart-data="engagement.evaluationChart"
          :options="engagement.chartOptions"
          :textMiddle="engagement.evaluation.evaluationScaleAverage"
        ></doughnutChart>
      </div>

      <div class="col-10 border-left if-small-no-border">
        <div class="row border-bottom if-small-add-border">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Communication</h5></div>
            <p>
              Communication shows if an employee can communicate effectively by
              listening and understanding the situation, aswell as expressing
              his ideas clearly.
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.evaluationSubCharts.communication"
              :options="engagement.chartOptions"
              :textMiddle="
                engagement.evaluation.evaluationSubscale.communicationPercentage
              "
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <ul>
              <li>
                Communication might be hard if there is a language barrier, so
                be considerate of this barrier
              </li>
              <li>
                Communication is a two-way street, so if you want an employee to
                listen you have to listen to them aswell
              </li>
            </ul>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Relationships</h5></div>
            <p>
              Relationships are measured by an employee’s ability to build and
              sustain relationships, collaborate across departments and his
              ability to acknowledge the contributions of others
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.evaluationSubCharts.relationships"
              :options="engagement.chartOptions"
              :textMiddle="
                engagement.evaluation.evaluationSubscale.relationshipPercentage
              "
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <ul>
              <li>
                Recognize an employee’s ability to collaborate effectively
              </li>
              <li>
                As a supervisor or managers, also acknowledge their
                contributions
              </li>
              <li>Thank them for being a member of the team</li>
            </ul>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Planning</h5></div>
            <p>
              Planning show if an employee can anticipate problems and take
              corrective measures and can balance his work loads
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.evaluationSubCharts.planning"
              :options="engagement.chartOptions"
              :textMiddle="
                engagement.evaluation.evaluationSubscale.planningPercentage
              "
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <ul>
              <li>Help employee’s if they have trouble planning their time</li>
              <li>Let employee’s take corrective action</li>
              <li>Make sure not to overwork employees</li>
            </ul>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Results</h5></div>
            <p>
              Results show if an employee can stay focussed on his work, clarify
              his decisions, achieve the desired results and takes personal
              responsibility for his actions
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.evaluationSubCharts.results"
              :options="engagement.chartOptions"
              :textMiddle="
                engagement.evaluation.evaluationSubscale.resultsPercentage
              "
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <ul>
              <li>
                Try talking to them about what is hindering them from doing
                their work effectively
              </li>
              <li>
                Ask them to declare downtimes and submit feedback to improve
                company performance
              </li>
            </ul>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Resilience</h5></div>
            <p>
              The capability of dealing with mulitiple demands, continues
              working through setbacks, is open to new ideas and actively
              supports organizations change efforts
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.evaluationSubCharts.resilience "
              :options="engagement.chartOptions"
              :textMiddle="
                engagement.evaluation.evaluationSubscale.resiliencePercentage
              "
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <ul>
              <li>Appreciate hard working and loyal employees</li>
              <li>
                If an employee has had a hard week but pulled through, give them
                some more fun tasks
              </li>
            </ul>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Supporting</h5></div>
            <p>
              Supporting indicate an employee’s willingness to practice and
              promote the company’s values, follows company policy, acts honest
              and treats others fairly and respectfully
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.evaluationSubCharts.supporting"
              :options="engagement.chartOptions"
              :textMiddle="
                engagement.evaluation.evaluationSubscale.supportingPercentage
              "
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <ul>
              <li>
                Being honest and respectful to employees builds trust, this
                trust makes it more likely they will also be more honest and
                respectful to other employees.
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Progression</h5></div>
            <p>
              Progression is the way an employee develops himself by knowing his
              weaknesses and stregths, learning from experience, and actively
              improving
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.evaluationSubCharts.progression"
              :options="engagement.chartOptions"
              :textMiddle="
                engagement.evaluation.evaluationSubscale.progressionPercentage
              "
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <ul>
              <li>
                Make them feel like they are doing a good job and reward
                progression.
              </li>
              <li>Give them a new challenge or an important job</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import { Doughnut, mixins } from "vue-chartjs";

import { adjustColor } from "@/mixins/engagement/adjustChartColor.js";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp, adjustColor],
  props: ["chartData", "engagement"],
  components: {
    doughnutChart,
  },
  data() {
    return {};
  },

  mounted() {},
  methods: {
    async addChartData(value) {
      const chartData = {
        datasets: [
          {
            data: [value, 100 - value],
            backgroundColor: [this.adjustColor(value)],
            borderWidth: 0,
          },
        ],
        labels: [""],
      };

      return await chartData;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>